import { InjectionToken } from '@angular/core';
import { persistState, PersistState } from '@datorama/akita';

export const PERSIST_STATE = new InjectionToken<PersistState>('PERSIST_STATE', {
  providedIn: 'root',
  factory: () => persistState(),
});
